import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../lib/net";
import Wnd_Ok from "../../lib/ui/wnd_ok";
import sso from "../../sso";

class User_Session extends React.Component {
  constructor(props, context) {
    super(props);

    this.store = props.store;
    this.state = {};
    this.state.bqa = [];
    this.state.tra = [];
    this.state.msg = {};

    this.state.selectedValue = ''; 
    this.state.items = [
           { name: 'Pitchers Örebro', value: 'S0002462' },
          { name: 'Pitchers Test', value: 'S0009999' },
          { name: 'Pitchers T10', value: 'S0009980' },
          { name: 'Harbour', value: 'S0002142' },
          { name: 'Bryggan', value: 'S0002141' },
          { name: 'Söder Park', value: 'S0002502' },
          { name: 'Brovakt', value: 'S0002371' }
        ];

   }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      //this.trs();
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
    tab_style(tabid) {
      var css = {};
      css.display = "none";
      if(this.state.tabval === tabid) css.display = "block";
      return css;
    }
    wnd_close() {
		this.props.ctx.setState({ wnds: {} });
		//this.props.cb();
	};
    tb_style() {
        var css = {};
        css.height = window.innerHeight - 275;
        return css;
    }
    cssCols (cid) {
        var css = {};
        if(this.state.cols[cid]) css.width = this.state.cols[cid].toString() + "px";
        //if(cid == "c01") alert(JSON.stringify(this.state.cols[cid]));
        return css;
    }
  syncCols (tb) {

    if (!document.getElementById(tb)) return;

    var cols = {};
    var ix = document.getElementById(tb).rows.length - 1;
    var ic = document.getElementById(tb).rows[0].cells.length;
    var ci = 0;
    while(ci < ic) {
        var cxi = ci + 1;
        var col = "c" + cxi.toString().padStart(2, "0");
        cols[col] = document.getElementById(tb).rows[ix].cells[ci].clientWidth + 1;
        ci = ci + 1;
    }
    this.setState({cols: cols });
    //alert(JSON.stringify(this.state.cols));
    //this.forceUpdate();
  };
  trs() {
    var self = this;
    var prm = {};
    prm.req = "pos.pos_bq.trs";
    prm.avd = this.state.avd;
    //prm.fplu = datum;
    //prm.tplu = datum;

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({tra: ret.rca });
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
  row_bong(row) {
    var self = this;
    var prm = {};
    prm.req = "pos.pos_bq.bongrow";
    prm.row = row;
    prm.status = "09";

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        //self.setState({bqa: ret.rca });
        //toastr.success("OK", "SAPI");
        var msg = { ok: true, text: "BONGAD ..." };
        self.setState({msg: msg });
        setTimeout(function(){
            self.setState({msg: {} });
        }, 1000);
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
    seo_set() {
        var self = this;

        sso.seo.auto = "csc";
        sso.sdo.stxt = "";
        sso.sdo.sid = "";

        var xss = JSON.stringify(sso);
        sessionStorage.setItem("svp_sso", xss);
    }

    sid_clear() {
        sso.sdo.stxt = "";
        sso.sdo.sid = "";

        var xss = JSON.stringify(sso);
        sessionStorage.setItem("svp_sso", xss);
    }
    sid_set() {
        
        if (this.state.selectedValue == "") {
        
        sso.sdo.stxt = "S0009980";
        sso.sdo.sid = "S0009980";

        sso.seo.sid = "S0009980";
        }
        else {
            sso.sdo.stxt = this.state.selectedValue;
            sso.sdo.sid = this.state.selectedValue;
            sso.seo.sid = this.state.selectedValue;

            sso.seo.name = this.getNameFromValue(this.state.selectedValue);
            sso.seo.company = this.getNameFromValue(this.state.selectedValue);
    }
        var xss = JSON.stringify(sso);
        sessionStorage.setItem("svp_sso", xss);
    }
    handleChange = (event) => {
        this.setState({ selectedValue: event.target.value });
    };
    
      getNameFromValue = (value) => {
        const item = this.state.items.find((item) => item.value === value);
        return item ? item.name : '';
    };

  render() {
    if(!this.props.wnds.userses) return "";

    var title = this.props.title;
    if(!title) title = "Titel";

	var html =
        <div className="mx_base">
        { this.props.wnds.backdrop ? <div className="mx_backdrop" /> : null }
        <div className="mx_dlg mx_90 flex-col" style={ this.dlg_style() }>
        <div className="mx_content flex">

            <div className="flex-row" style={{color: "#000", padding:"5px",height:"35px"}}>
                    <div className="flex-col flex">
                        <div>MIN SESSION</div>
                    </div>
                    <div className="flex-col">
                        <div>UPPDATERA</div>
                    </div>
            </div>
            <div className="divider_orange"></div>

            <div className="web-row">
                <div className="flex-col" onClick={() => this.seo_set() }>
                    <div>SEO SET</div>
                </div>
            </div>

            <div className="web-row text-center" style={{color: "#000", padding:"5px",height:"35px"}}>
                SYSTEM: { sso.sdo.sid } / { sso.sdo.stxt }
            </div>

            <div className="web-row text-center" style={{color: "#000", padding:"5px",height:"35px"}}>
                AUTO: { sso.seo.auto }
            </div>
            <div className="web-row">
            <pre className="flex" style={{color: "#000", padding:"5px"}}>
                { JSON.stringify(sso.seo, null, 2) }
            </pre>
                <pre className="flex" style={{color: "#000", padding:"5px"}}>
                { JSON.stringify(sso.sdo, null, 2) }
            </pre>
            

            </div>
            <div className="web-row">
            <select value={this.state.selectedValue} onChange={this.handleChange}>
          <option value="" disabled>Select an item</option>
          {this.state.items.map((item, index) => (
            <option key={index} value={item.value}>{item.name}</option>
          ))}
        </select>
        <button className="btn btn-hw-blue w250" onClick={() => this.sid_set() } >
                SET SID
            </button>
        </div>
        
        </div>

        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250 ripple" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <div className="flex"></div>
            <button className="btn btn-hw-blue w250" onClick={() => this.sid_clear() } >
                RENSA SID
            </button>
            <div className="flex"></div>
            <button className="btn btn-hw-blue w250" onClick={() => this.sid_set() } >
                SET SID
            </button>
            <div className="flex"></div>
            <button className="btn btn-hw-green w250 ripple" onClick={(event) => this.prn(event) } >
                SKRIV UT
            </button>
        </div>
      </div>
        <Wnd_Ok msg={this.state.msg} ctx={this} />
    </div>
	;
	return html;
  };
}

export default User_Session;